import * as React from 'react'

import { Box, Button, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onSubmit: () => void
  title: string
  needsValidation: boolean
}

const ConfigureIncidence = ({ onClose, onSubmit, title, needsValidation }: Props) => {
  const [validated, setValidated] = React.useState(needsValidation)

  const handleSubmit = () => {
    onSubmit()
    onClose()
  }

  return (
    <Modal
      illustration="document-edit"
      title={`${i18n.t('bookkeepers.clients.preferences.configuration.modal.configure')} ${title}`}
      description={i18n.t('bookkeepers.clients.preferences.configuration.modal.description')}
      onClose={onClose}
      onSubmit={handleSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('bookkeepers.clients.preferences.configuration.modal.cancel')}
          </Button>
          <Button submit>
            {i18n.t('bookkeepers.clients.preferences.configuration.modal.submit')}
          </Button>
        </>
      }
    >
      <Box background="grey200" flexDirection="row" padding="s16" borderRadius={{ all: 'abs008' }}>
        <Box flexDirection="column">
          <Text.Normal color="grey1000" weight="semibold">
            {validated
              ? i18n.t(
                  'bookkeepers.clients.preferences.configuration.modal.validation_enabled_title'
                )
              : i18n.t(
                  'bookkeepers.clients.preferences.configuration.modal.validation_disabled_title'
                )}
          </Text.Normal>
          <Text.Normal>
            {validated
              ? i18n.t(
                  'bookkeepers.clients.preferences.configuration.modal.validation_enabled_description'
                )
              : i18n.t(
                  'bookkeepers.clients.preferences.configuration.modal.validation_disabled_description'
                )}
          </Text.Normal>
        </Box>
        <Box alignItems="flexEnd">
          <TogglerCheckbox value={validated} onChange={() => setValidated(!validated)} />
        </Box>
      </Box>
    </Modal>
  )
}

export default ConfigureIncidence
